module.exports = __webpack_public_path__ + "img/1526313772.0b7baeda.jpg";